import { valueExists } from '@mw/helpers';

import { ChannelType, MiscChatbotStory } from '~/constants';

const getStoryIDFromAgents = (agents) => {
  if (agents.length === 0) return null;

  const chatbotStoryIDs = agents
    .filter((agent) => valueExists(agent.config.chatbot))
    .map((agent) => agent.config.chatbot.story_id);

  return chatbotStoryIDs.reduce((reducedStoryID, storyID) => {
    if (storyID === reducedStoryID) {
      return storyID;
    }

    return MiscChatbotStory.KEY;
  }, chatbotStoryIDs[0]);
};

const getChannelChatbotStoryID = (channel) => {
  if (channel.type === ChannelType.SMS) {
    return getStoryIDFromAgents(channel.agents);
  }

  return channel?.chatbot?.story_id;
};

export { getChannelChatbotStoryID };
